import React, { useEffect, useState, useRef } from 'react';
import '../assets/css/custom.css';
import '../assets/css/client.css';
import '../assets/css/font-awesome.css';
import '../assets/css/sweetalert.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/steps.css';
import { FaChevronDown } from "react-icons/fa";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDeleteLeft, faEdit, faPlus, faRemove, faSort, faTrash, faEllipsisVertical, faTimes, faCheck, faTrashCan, faPenToSquare, } from '@fortawesome/free-solid-svg-icons';
// import { faEdit, faPlus, faSort, faEllipsisVertical, faTrash } from '@fortawesome/free-solid-svg-icons';
import clientlogo from '../assets/img/user1.jpg';
import clientDemoImg from "../assets/img/building.jpg";
import NoBuilding from "../assets/img/no-building.png"; 
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import ReactDOM from "react-dom";
import { commonAPI } from "../services/CommonAPIService"
import Menus from "./menus";
// import { Wizard, Steps, Step, WithWizard } from "react-multistep-wizard";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Stepper, Step, StepLabel, StepContent } from '@mui/material';
import stopMark from '../assets/img/stop.png';
import { ErrorSource } from "../common/constants";

function Building() {

    const [show, setShow] = useState(false);
    const [DeleteShow, setDeleteShow] = useState(false);
    const [BuildingList, setBuildingList] = useState(null);
    const [activeStep, setActiveStep] = useState(0);
    const steps = ['Step 1', 'Step 2', 'Step 3', 'Step 4'];
    // const [buildingName,setBuildingName] = useState("");
    const [BuildingName, setBuildingName] = useState("");
    const [BuildingShortName, setBuildingShortName] = useState("");
    const [BuildingId, setBuildingId] = useState("");
    const [ClientName, setClientName] = useState([]);
    const [ClientList, setClientList] = useState("");
    const [ClientId, setClientId] = useState("");
    const [ClientIdSelected, setClientIdSelected] = useState("");
    const [PhoneNumber, setPhoneNumber] = useState("");
    const [AltPhoneNumber, setAltPhoneNumber] = useState("");
    const [Email, setEmail] = useState("");
    const [AltEmail, setAltEmail] = useState("");
    const [SpocName, setSpocName] = useState("");
    const [SpocMobileNumber, setSpocMobileNumber] = useState("");
    const [MobileNumber, setMobileNumber] = useState("");
    const [AltSpocName, setAltSpocName] = useState("");
    const [SpocEmail, setSpocEmail] = useState("");
    const [AltaltSpocEmail, setAltaltSpocEmail] = useState("")
    const [AddressLineOne, setAddressLineOne] = useState("")
    const [AddressLineTwo, setAddressLineTwo] = useState("")
    const [City, setCity] = useState("");
    const [SelectCity, setSelectCity] = useState("");
    const [State, setState] = useState("");
    const [SelectState, setSelectState] = useState("");
    const [Country, setCountry] = useState("");
    const [SelectCountry, setSelectCountry] = useState(["1", "India"]);
    const [PinCode, setPinCode] = useState("")
    const [Logo, setLogo] = useState("")
    const [LocalEndPoint, setLocalEndPoint] = useState("")
    const [altSPOCMobileNumber, setaltSPOCMobileNumber] = useState("")
    const [LocalDBName, setLocalDBName] = useState("")
    const [LocalDBServerName, setLocalDBServerName] = useState("")
    const [Loading, setLoading] = useState(false);
    const [UserData, setUserData] = useState("");
    const [AddBuildingBtn, setAddBuildingBtn] = useState(false);
    const [UpdateBuildingBtn, setUpdateBuildingBtn] = useState(false);
    const [oldVehicleIndex, setOldVehicleIndex] = useState(null)
    const [vehicleMenu, showVehicleMenu] = useState(null)
    const [selectedImageTwo, setSelectedImageTwo] = useState(null)
    const [selectedImageTwoShow, setSelectedImageTwoShow] = useState(null)
    const [SelectedBuildingId, setSelectedBuildingId] = useState(null)
    const [fullscreen, setFullscreen] = useState(true);
    const [isStateChange, setIsStateChange] = useState(false);
    const [MasterClientId, setMasterClientId] = useState("");
    const [MasterBuildingId, setMasterBuildingId] = useState("");
    const [MasterEdgeEndPoint, setMasterEdgeEndPoint] = useState("");
    const [MasterBtn, setMasterBtn] = useState(false);
    const [MasterBtnUpdate, setMasterBtnUpdate] = useState(false);
    const [WarningShow, setWarningShow] = useState(false);
    const [WarningUpdateShow, setWarningUpdateShow] = useState(false);
    const [ShowTag, setShowTag] = useState(false);
    const [Latitude, setLatitude] = useState("");
    const [Longitude, setLongitude] = useState("");
    

    const setInputValue = (item) => {
        setTimeout(() => {
            setIsStateChange(true);
        }, 1000);

        setShow(true)
        setShowTag(true)
        setAddBuildingBtn(false)
        setUpdateBuildingBtn(true)
        console.log("item", item)
        setBuildingId(item.buildingId)
        setBuildingName(item.buildingName)
        setBuildingShortName(item?.buildingShortName)
        setClientId(item.clientId)
        setClientName(item.clientName)
        setPhoneNumber(item.phoneNumber)
        setAltPhoneNumber(item.altPhoneNumber)
        setEmail(item.email)
        setAltEmail(item.altEmail)
        setSpocName(item.spocName)
        setSpocMobileNumber(item.spocMobileNumber)
        setSpocEmail(item.spocEmail)
        setAltSpocName(item.altSPOCName)
        setAltaltSpocEmail(item.altSPOCEmail)
        setaltSPOCMobileNumber(item.altSPOCMobileNumber)
        setAddressLineOne(item.addressLine1)
        setAddressLineTwo(item.addressLine2)
        setSelectCountry(["1", "India"])
        console.log("updated State arry", State);
        const itemState = item?.state
        const stateObj = State?.filter((item) => item?.stateName == itemState);
        console.log("updated State arry", [stateObj[0]?.stateId, stateObj[0]?.stateName]);
        setSelectState([stateObj[0]?.stateId, stateObj[0]?.stateName])
        CityUpdate();
        setSelectCity(item?.city)
        setPinCode(item.pinCode)
        // var decodedString2 = atob(item?.logo);
        // console.log("atob", decodedString2)
        setSelectedImageTwo(item?.logo)
        setSelectedImageTwoShow(item?.logo)
        setLatitude(item.latitude)
        setLongitude(item.longitude)
        setLocalEndPoint(item.localServerAPIEndPoint)
        setLocalDBName(item.localDBName)
        setLocalDBServerName(item.localDBServerName)
        setLocalEndPoint(item.localServerAPIEndPoint)
        setMasterBtn(false)
        setMasterBtnUpdate(false)

    };

    const CloseModal = () => {
        console.log("I am Call ");
        setShow(false)
        setSelectState("")
        setSelectCity("")
        setIsStateChange(false)
        setBuildingId("")
            setBuildingName("")
            setBuildingShortName('')
            setClientName("")
            setPhoneNumber("")
            setAltPhoneNumber("")
            setEmail("")
            setAltEmail("")
            setSpocName("")
            setSpocMobileNumber('')
            setSpocEmail("")
            setAltSpocName("")
            setAltaltSpocEmail("")
            setaltSPOCMobileNumber("")
            setAddressLineOne("")
            setAddressLineTwo("")
            setSelectCity("")
            setSelectState("")
            setPinCode("")
            setSelectedImageTwo("")
            setSelectedImageTwoShow("")
            setLatitude("")
            setLongitude("")
            setLocalEndPoint("")
            setLocalDBName("")
            setLocalDBServerName("")
            setLocalEndPoint("")
    }

    const openCreateModal = (item) => {
        if (ClientIdSelected) {
            setShowTag(false)
            setShow(true)
            setAddBuildingBtn(true)
            setUpdateBuildingBtn(false)
            console.log("item", item)
            setBuildingId("")
            setBuildingName("")
            setBuildingShortName('')
            setClientId(ClientIdSelected)
            setClientName("")
            setPhoneNumber("")
            setAltPhoneNumber("")
            setEmail("")
            setAltEmail("")
            setSpocName("")
            setSpocMobileNumber('')
            setSpocEmail("")
            setAltSpocName("")
            setAltaltSpocEmail("")
            setaltSPOCMobileNumber("")
            setAddressLineOne("")
            setAddressLineTwo("")
            setSelectCity("")
            setSelectState("")
            setSelectCountry(["1", "India"])
            setPinCode("")
            setSelectedImageTwo("")
            setSelectedImageTwoShow("")
            setLatitude("")
            setLongitude("")
            setLocalEndPoint("")
            setLocalDBName("")
            setLocalDBServerName("")
            setLocalEndPoint("")
            setMasterBtn(false)
            setMasterBtnUpdate(false)
        } else {
            toast.warning("Please select Client");
        }

    };


    const GetCountryList = async () => {
        try {
            //   setLoading(true);
            let response = await commonAPI("Country");
            console.log("Country", response);
            if (response?.success === true) {

                setCountry(response.data);
                // setLoading(false);

            } else {
                toast.error("Something went wrong");
                // setLoading(false);
            }
        } catch (error) {
            console.log(error);

            setLoading(false);
            const bodydata = {
                userId: UserData?.userId,
                mobileNumber: UserData?.mobileNumber,
                requestJSON: null,
                uri: "api/Common/Country",
                errorNumber: "CL01",
                errorSource: ErrorSource,
                errorSummary: error?.message,
                errorDescription: error?.message,
                fileClassName: "building.js",
                functionName: "GetCountryList",
            };
            console.log("body", bodydata);
            let response = await commonAPI("ErrorLogMaster", bodydata);
            console.log("statusCode", response);
            if (response?.success == true && response?.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };


    const GetStateList = async () => {
        try {
            //   setLoading(true);
            let response = await commonAPI("State", undefined, SelectCountry[0]);
            console.log("State", response);
            if (response?.success === true) {

                setState(response?.data);
                // setLoading(false);

            } else {
                toast.error("Something went wrong");
                // setLoading(false);
            }
        } catch (error) {
            

            setLoading(false);
            const bodydata = {
                userId: UserData?.userId,
                mobileNumber: UserData?.mobileNumber,
                requestJSON: null,
                uri: "api/Common/State",
                errorNumber: "SL01",
                errorSource: ErrorSource,
                errorSummary: error?.message,
                errorDescription: error?.message,
                fileClassName: "building.js",
                functionName: "GetStateList",
            };
            console.log("body", bodydata);
            let response = await commonAPI("ErrorLogMaster", bodydata);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };


    // const StateUpdate = async () => {
    useEffect(() => {
        if (SelectCountry) {
            GetStateList();
        }

    }, [SelectCountry]);
    // }


    const GetCityList = async () => {
        try {
            //   setLoading(true);
            let response = await commonAPI("City", undefined, SelectState[0]);
            console.log("State", response);
            if (response?.success === true) {

                setCity(response?.data);

            } else {
                toast.error("Something went wrong");
            }
        } catch (error) {
            console.log(error);

            setLoading(false);
            const bodydata = {
                userId: UserData?.userId,
                mobileNumber: UserData?.mobileNumber,
                requestJSON: null,
                uri: "api/Common/City",
                errorNumber: "CL01",
                errorSource: ErrorSource,
                errorSummary: error.message,
                errorDescription: error.message,
                fileClassName: "client.js",
                functionName: "GetCityList",
            };
            console.log("body", bodydata);
            let response = await commonAPI("ErrorLogMaster", bodydata);
            console.log("statusCode", response);
            if (response.success == true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };

    useEffect(() => {
        if (!ShowTag) {
            if (SelectState[0]) {
                GetCityList();
                setSelectCity("0")
                console.log("it is run")
            }
        } else {
            if (SelectState[0]) {
                GetCityList();
                console.log("it is run")
            }
        }

    }, [SelectState[0], UpdateBuildingBtn]);

    useEffect(() => {

        if (SelectState[0] && isStateChange) {
            setSelectCity("0")
        }

    }, [SelectState[0]]);

    const CityUpdate = async () => {
        if (SelectState[0]) {
            GetCityList();
        }
    }


    const CheckCity = async () => {
        if (!SelectState && SelectState == 0) {
            toast.warning("Please select state");
        }
    }

    const GetClientList = async () => {
        const auth = localStorage.getItem("primeProductCode");
        const ProductfactorKey = JSON.parse(auth);
        const endPointVariableKey = {
            ProductId: ProductfactorKey?.primeProductCode,
        }
        try {
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            setUserData(myUserData);
            console.log("UserData", myUserData)
            let response = await commonAPI("ClientLite", undefined, endPointVariableKey)
            console.log("Table client", response)
            if (response.success === true) {
                setClientList(response?.data);
            } else {
                toast.error("Something went wrong");
            }

        } catch (error) {
            console.log(error);

            setLoading(false);
            const bodydata = {
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Common/Client",
                "errorNumber": "CL01",
                "errorSource": "CuroNextPortal",
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "building.js",
                "functionName": "GetClientList",
            };
            console.log("body", bodydata);
            let response = await commonAPI("ErrorLogMaster", bodydata);
            console.log("statusCode", response);
            if (response?.success == true && response?.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }

        }

    }

    useEffect(() => {
        GetClientList();
        GetCountryList();
    }, [])

    const GetBuildingList = async () => {
        const auth = localStorage.getItem("primeProductCode");
        const ProductfactorKey = JSON.parse(auth);
        const endPointVariableKey = {
            ProductId: ProductfactorKey?.primeProductCode,
        }

        try {
            setLoading(true);
            let response = await commonAPI("Building", undefined, endPointVariableKey)
            console.log("Table", response?.data)
            if (response?.success === true) {
                console.log("Table building", ClientIdSelected)
                if (ClientIdSelected) {
                    const tempData = response?.data?.filter((item) => item?.clientId == ClientIdSelected)
                    console.log("Table building tempdata", tempData)
                    setBuildingList(tempData);
                    setLoading(false);
                } else {
                    // const filterData = [];
                    // for(var i=0; i< response.data.length; i++) {
                    //     filterData=response.data.sort(response.data[i].clientId);
                    //  }

                    // const filterData = response.data.sort();
                    // const filterData = response.data.sort((a, b) => a.clientId - b.clientId);
                    setBuildingList(response?.data);
                    // if(response.data == "ASC"){
                    //     const shorted = [...BuildingList].sort((a,b) =>
                    //       a.toString() > b.toString() ? 1 : -1
                    //     );
                    //     console.log("shorted-table", shorted)
                    //   }
                    // response.data.sort(function(response.data.clientId){return a.year - b.year});
                    // const tempData = response?.data?.filter((item)=> item?.clientId)
                    // console.log("filtered Data", filterData)

                    setLoading(false);
                }

            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": UserData.userId,
                "mobileNumber": UserData.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Common/building",
                "errorNumber": "GB01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "building.js",
                "functionName": "GetBuildingList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }

    const DeleteBuilding = async () => {
        const auth2 = localStorage.getItem("token");
        const TokenData = JSON.parse(auth2);
        const bodydata = {
            "buildingId": SelectedBuildingId?.buildingId,
            "modifiedUserId": JSON.stringify(UserData?.userId), // Need to be replaced
            // "modifiedUserId": item.modifiedUserId,
        };
        try {
            setLoading(true);

            console.log("body", bodydata);
            let response = await commonAPI("BuildingDelete", bodydata)
            //   const response = await fetch(`http://api-test.curonext.com/api/Master/Building/`, {
            //     // let response = await fetch(`${apiURL}/DAR/DARReportToHOD`, {  
            //       method: "DELETE",
            //       headers: { 'Content-Type': 'application/json'},
            //       body: bodydata

            //   })
            //   const statusCode = response
            console.log("statusCode", response)
            if (response?.success == true & response?.message.length == 0) {
                GetBuildingList()
                const localEndPointResponse = SelectedBuildingId?.localServerAPIEndPoint;
                console.log("it is run", localEndPointResponse)
                // EdegApi();
                const bodyJson = {
                    "buildingId": SelectedBuildingId?.buildingId,
                    "modifiedUserId": JSON.stringify(UserData?.userId),
                }
                console.log("bodyJSON", bodyJson)
                let EdegApi = await fetch(`${localEndPointResponse}/api/Master/Building`, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${TokenData?.token}`,
                    },
                    body: JSON.stringify(bodyJson),
                });
                EdegApi = await EdegApi.json();
                if (EdegApi?.success == true) {
                    toast.success("Building Deleted");
                    setLoading(false);
                    setDeleteShow(false);
                    GetBuildingList();
                } else {
                    setLoading(false);
                    toast.error("Something went wrong");
                }
                console.log("edeg response", EdegApi)

            } else {
                toast.error(response.message[0]);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            const bodyError = {
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": bodydata,
                "uri": "/api/Common/building",
                "errorNumber": "DB01",
                "errorSource": "CuroNextPortal",
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "building.js",
                "functionName": "DeleteBuilding",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }

        }

    }



    useEffect(() => {
        GetBuildingList();
    }, [ClientIdSelected])


    const addNewBuilding = async () => {
        const auth2 = localStorage.getItem("token");
        const TokenData = JSON.parse(auth2);
        const auth = localStorage.getItem("primeProductCode");
        const ProductfactorKey = JSON.parse(auth);
        const buildingDataTwo = {
            buildingName: BuildingName,
            buildingShortName: BuildingShortName,
            clientId: ClientIdSelected,
            clientName: ClientName,
            phoneNumber: PhoneNumber,
            altPhoneNumber: AltPhoneNumber,
            email: Email,
            altEmail: AltEmail,
            spocName: SpocName,
            spocMobileNumber: SpocMobileNumber,
            spocEmail: SpocEmail,
            altSPOCName: AltSpocName,
            altSPOCMobileNumber: altSPOCMobileNumber,
            altSPOCEmail: AltaltSpocEmail,
            addressLine1: AddressLineOne,
            addressLine2: AddressLineTwo,
            city: SelectCity,
            state: SelectState[1],
            country: SelectCountry[1],
            pinCode: PinCode,
            logo: selectedImageTwoShow,
            latitude: Latitude,
            longitude: Longitude,
            localServerAPIEndPoint: LocalEndPoint,
            localDBName: LocalDBName,
            localDBServerName: LocalDBServerName,
            createdUserId: UserData.userId.toString(),
            productId: ProductfactorKey?.primeProductCode
        }
        // console.log{}
        try {
            setLoading(true);
            if (!selectedImageTwo) {
                setLoading(false)
                toast.warning("Please upload Logo");
            } else if (!BuildingName) {
                setLoading(false)
                toast.warning("Please enter Building Name");
            } else if (!BuildingShortName) {
                setLoading(false)
                toast.warning("Please enter Building Short Name");
            } else if (!PhoneNumber) {
                setLoading(false)
                toast.warning("Please enter Phone Number");
            }else if ( PhoneNumber.length != 10) {
                setLoading(false);
                toast.warning("Please enter Valid Phone Number"); 
            }else if (AltPhoneNumber && AltPhoneNumber.length != 10) {
                setLoading(false);
                toast.warning("Please enter Valid Alt Phone Number");
            } else if (!Email) {
                setLoading(false)
                toast.warning("Please enter Email");
            }else if (SpocMobileNumber && SpocMobileNumber.length != 10) {
                setLoading(false);
                toast.warning("Please enter Valid SPOC Mobile Number");   
            }else if (altSPOCMobileNumber && altSPOCMobileNumber.length != 10) {
                setLoading(false);
                toast.warning("Please enter Valid Alt SPOC Mobile Number");   
            } else if (!AddressLineOne) {
                setLoading(false)
                toast.warning("Please enter Address Line 1");
            } else if (!SelectState || SelectState == "0") {
                setLoading(false);
                toast.warning("Please select State");
            } else if (!SelectCity || SelectCity == "0") {
                setLoading(false);
                toast.warning("Please select City");
            } else if (!SelectCountry) {
                setLoading(false);
                toast.warning("Please select Country");
            } else if (!PinCode) {
                setLoading(false);
                toast.warning("Please enter Pincode");
            } else if (!LocalDBServerName) {
                setLoading(false)
                toast.warning("Please enter Edge DB Server IP/ Domain");
            } else if (!LocalDBName) {
                setLoading(false)
                toast.warning("Please enter Edge Server DB Name");
            } else if (!LocalEndPoint) {
                setLoading(false)
                toast.warning("Please enter Edge Server API End Point ");

            } else {
                let response = await commonAPI("BuildingAdd", buildingDataTwo)
                console.log("bodyData", buildingDataTwo)
                //   const jsonResponse = await response.json();
                console.log("response", response)
                //   console.log("add Vehicle", response.success == true);

                if (response?.success == true) {
                    console.log("it is run", response)
                    // const localEndPointResponse = response.data.localServerAPIEndPoint;
                    // console.log("it is run", localEndPointResponse)
                    // EdegApi();
                    GetBuildingList()
                    setMasterClientId(response?.data?.clientId)
                    setMasterBuildingId(response?.data?.buildingId)
                    setMasterEdgeEndPoint(response?.data?.localServerAPIEndPoint)
                    const bodyJson = {
                        buildingName: BuildingName,
                        buildingShortName: BuildingShortName,
                        clientId: response?.data?.clientId,
                        buildingId: response?.data?.buildingId
                    }
                    try {
                        console.log("bodyJSON", bodyJson)
                        let EdegApi = await fetch(`${response?.data?.localServerAPIEndPoint}/api/Master/Building`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${TokenData?.token}`,
                            },
                            body: JSON.stringify(bodyJson),
                        });

                        if (EdegApi.status != 200) {
                            setLoading(false)
                            // toast.warning("Building Not Added");
                            setMasterBtn(true);
                            setAddBuildingBtn(false);
                            setWarningShow(true)
                            return
                        } else {
                            EdegApi = await EdegApi.json();
                            // EdegApi = EdegApi.Json();
                            console.log("EdegApi", EdegApi)
                            if (EdegApi?.success == true) {
                                toast.success("Building Added");
                                GetBuildingList()
                                setLoading(false)
                                setShow(false);
                            } else {
                                toast.error(EdegApi?.message[0]);
                                setLoading(false);
                            }
                        }
                    } catch (error) {
                        setLoading(false)
                        // toast.warning("Building Not Added");
                        setMasterBtn(true);
                        setAddBuildingBtn(false);
                        setWarningShow(true)
                        return
                    }




                } else {
                    toast.error(response?.message[0]);
                    setLoading(false)
                }
            }
        } catch (error) {
            setLoading(false);
            const bodyError = JSON.stringify({
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": buildingDataTwo,
                "uri": "/api/Common/Building",
                "errorNumber": "AB01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "building.js",
                "functionName": "addNewBuilding",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong111");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };

    const addNewMasterBuilding = async () => {
        const auth2 = localStorage.getItem("token");
        const TokenData = JSON.parse(auth2);
        const bodyJson = {
            buildingName: BuildingName,
            buildingShortName: BuildingShortName,
            clientId: MasterClientId,
            buildingId: MasterBuildingId
        }
        try {
            console.log("bodyJSON", bodyJson)
            setLoading(true)
            let EdegApi = await fetch(`${LocalEndPoint}/api/Master/Building`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${TokenData?.token}`,
                },
                body: JSON.stringify(bodyJson),
            });
            if (EdegApi?.status != 200) {
                setLoading(false)
                // toast.warning("Building Not Added");
                setMasterBtn(true);
                setAddBuildingBtn(false);
                setWarningShow(true)
                return
            } else {
                EdegApi = await EdegApi?.json();
                // EdegApi = EdegApi.Json();
                console.log("EdegApi", EdegApi)
                if (EdegApi?.success == true) {
                    toast.success("Building Added");
                    GetBuildingList()
                    setLoading(false)
                    setShow(false);
                } else {
                    toast.error(EdegApi?.message[0]);
                    setLoading(false)
                }
            }
        } catch (error) {
            setLoading(false);
            const bodyError = JSON.stringify({
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": bodyJson,
                "uri": "/api/Master/Building",
                "errorNumber": "AB01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "building.js",
                "functionName": "addNewBuilding",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                setLoading(false)
                setMasterBtn(true);
                setAddBuildingBtn(false);
                setWarningShow(true)
                return
            } else {
                setLoading(false)
                // toast.warning("Building Not Added");
                setMasterBtn(true);
                setAddBuildingBtn(false);
                setWarningShow(true)
                return
            }
        }
    }

    const UpdateBuilding = async () => {
        const auth2 = localStorage.getItem("token");
        const TokenData = JSON.parse(auth2);
        const buildingDataTwo = {
            buildingId: BuildingId,
            buildingName: BuildingName,
            buildingShortName: BuildingShortName,
            clientId: ClientId,
            clientName: ClientName,
            phoneNumber: PhoneNumber,
            altPhoneNumber: AltPhoneNumber,
            email: Email,
            altEmail: AltEmail,
            spocName: SpocName,
            spocMobileNumber: SpocMobileNumber,
            spocEmail: SpocEmail,
            altSPOCName: AltSpocName,
            altSPOCMobileNumber: altSPOCMobileNumber,
            altSPOCEmail: AltaltSpocEmail,
            addressLine1: AddressLineOne,
            addressLine2: AddressLineTwo,
            city: SelectCity,
            state: SelectState[1],
            country: SelectCountry[1],
            pinCode: PinCode,
            logo: selectedImageTwoShow,
            latitude: Latitude,
            longitude: Longitude,
            localServerAPIEndPoint: LocalEndPoint,
            localDBName: LocalDBName,
            localDBServerName: LocalDBServerName,
            modifiedUserId: JSON.stringify(UserData.userId) //Need to be change
        }
        // console.log{}
        try {
            setLoading(true);
            if (!selectedImageTwo) {
                setLoading(false)
                toast.warning("Please upload Logo");
            } else if (!BuildingName) {
                setLoading(false)
                toast.warning("Please enter Building Name");
            } else if (!BuildingShortName) {
                setLoading(false)
                toast.warning("Please enter Building Short Name");
            } else if (!PhoneNumber) {
                setLoading(false)
                toast.warning("Please enter Phone Number");
            }else if ( PhoneNumber.length != 10) {
                setLoading(false);
                toast.warning("Please enter Valid Phone Number"); 
            }else if (AltPhoneNumber && AltPhoneNumber.length != 10) {
                setLoading(false);
                toast.warning("Please enter Valid Alt Phone Number");
            } else if (!Email) {
                setLoading(false)
                toast.warning("Please enter Email");
            }else if (SpocMobileNumber && SpocMobileNumber.length != 10) {
                setLoading(false);
                toast.warning("Please enter Valid SPOC Mobile Number");   
            }else if (altSPOCMobileNumber && altSPOCMobileNumber.length != 10) {
                setLoading(false);
                toast.warning("Please enter Valid Alt SPOC Mobile Number");   
            } else if (!AddressLineOne) {
                setLoading(false)
                toast.warning("Please enter Address Line 1");
            } else if (!SelectState || SelectState == "0") {
                setLoading(false);
                toast.warning("Please select State");
            } else if (!SelectCity || SelectCity == "0") {
                setLoading(false);
                toast.warning("Please select City");
            } else if (!SelectCountry) {
                setLoading(false);
                toast.warning("Please select Country");
            } else if (!PinCode) {
                setLoading(false);
                toast.warning("Please enter Pincode");
            } else if (!LocalDBServerName) {
                setLoading(false)
                toast.warning("Please enter Edge DB Server IP/ Domain");
            } else if (!LocalDBName) {
                setLoading(false)
                toast.warning("Please enter Edge Server DB Name");
            } else if (!LocalEndPoint) {
                setLoading(false)
                toast.warning("Please enter Edge Server API End Point ");
            } else {
                let response = await commonAPI("BuildingUpdate", buildingDataTwo)
                console.log("bodyData", buildingDataTwo)
                //   const jsonResponse = await response.json();
                console.log("response update", response)
                //   console.log("add Vehicle", response.success == true);

                if (response?.success == true) {
                    setLoading(false);
                    GetBuildingList()
                    console.log("it is run", response)
                    // const localEndPointResponse = response.data.localServerAPIEndPoint;
                    // console.log("it is run", localEndPointResponse)
                    // EdegApi();
                    const bodyJson = {
                        buildingName: BuildingName,
                        buildingShortName: BuildingShortName,
                        clientId: ClientId,
                        buildingId: BuildingId,
                        modifiedUserId: JSON.stringify(UserData?.userId)
                    }
                    try {
                        setLoading(true)
                        console.log("bodyJSON", bodyJson)
                        let EdegApi = await fetch(`${LocalEndPoint}/api/Master/Building`, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${TokenData?.token}`,
                            },
                            body: JSON.stringify(bodyJson),
                        });
                        if (EdegApi.status != 200) {
                            setLoading(false)
                            setMasterBtnUpdate(true);
                            setUpdateBuildingBtn(false);
                            setWarningUpdateShow(true)
                            return
                        } else {
                            EdegApi = await EdegApi?.json();
                            console.log("EdegApi", EdegApi)
                            if (response?.success == true) {
                                toast.success("Building Updated");
                                setLoading(false);
                                GetBuildingList();
                                setShow(false);
                            } else {
                                toast.error(response?.message[0]);
                                setLoading(false);
                            }
                            console.log("edeg response", EdegApi)
                        }

                    } catch (error) {
                        setLoading(false)
                        setMasterBtnUpdate(true);
                        setUpdateBuildingBtn(false);
                        setWarningUpdateShow(true)
                        return
                    }

                } else {
                    toast.error(response?.message[0]);
                    setLoading(false)
                }
            }
        } catch (error) {
            setLoading(false);
            const bodyError = JSON.stringify({
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": buildingDataTwo,
                "uri": "/api/Common/Building",
                "errorNumber": "AB01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "building.js",
                "functionName": "addNewBuilding",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
    };

    const UpdateMasterBuilding = async () => {
        const auth2 = localStorage.getItem("token");
        const TokenData = JSON.parse(auth2);
        const bodyJson = {
            buildingName: BuildingName,
            buildingShortName: BuildingShortName,
            clientId: ClientId,
            buildingId: BuildingId,
            modifiedUserId: JSON.stringify(UserData?.userId)
        }
        try {
            console.log("bodyJSON", bodyJson)
            setLoading(true)
            let EdegApi = await fetch(`${LocalEndPoint}/api/Master/Building`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${TokenData?.token}`,
                },
                body: JSON.stringify(bodyJson),
            });
            if (EdegApi?.status != 200) {
                setLoading(false)
                setMasterBtnUpdate(true);
                setUpdateBuildingBtn(false);
                setWarningUpdateShow(true)
                return
            } else {
                EdegApi = await EdegApi?.json();
                // EdegApi = EdegApi.Json();
                console.log("EdegApi", EdegApi)
                if (EdegApi?.success == true) {
                    toast.success("Building Updated");
                    GetBuildingList()
                    setLoading(false)
                    setShow(false);
                } else {
                    toast.error(EdegApi?.message[0]);
                    setLoading(false)
                }
            }
        } catch (error) {
            setLoading(false);
            const bodyError = JSON.stringify({
                "userId": UserData.userId,
                "mobileNumber": UserData.mobileNumber,
                "requestJSON": bodyJson,
                "uri": "/api/Master/Building",
                "errorNumber": "AB01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "building.js",
                "functionName": "addNewBuilding",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                setLoading(false)
                setMasterBtnUpdate(true);
                setUpdateBuildingBtn(false);
                setWarningUpdateShow(true)
                return
            } else {
                setLoading(false)
                setMasterBtnUpdate(true);
                setUpdateBuildingBtn(false);
                setWarningUpdateShow(true)
                return
            }
        }
    }


    function setVehicleIndex(index) {
        console.log(oldVehicleIndex == index, "oldVehicleIndex==index")
        if (oldVehicleIndex == index) {
            setOldVehicleIndex(null)
            showVehicleMenu(null)

        }
        else {
            showVehicleMenu(index)
            setOldVehicleIndex(index)

        }
        // setHideVehicleMenu(true)
    }

    const ShowDeleteModal = (item) => {
        setDeleteShow(true);
        setSelectedBuildingId(item)

    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => {
            if (prevActiveStep >= steps.length - 1) {
                addNewBuilding()

                console.log("i am not called")
                // Assuming 'steps' is your array of step labels
                return 0; // Reset to first step
            } else {
                // console.log(buildingName)
                // if(BuildingName.current.value=="")
                // {
                //     console.log(BuildingShortName.current.value)
                //     alert("please enter building name")
                //     return prevActiveStep
                // }

                // else{
                //     console.log("Datatatat")
                return prevActiveStep + 1;
                // }
                // console.log(BuildingName.current.value);
                // console.log("i am called")

            }
        });
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleFileInputChangeTwo = (event) => {
        const file = event.target.files[0];
        if (file) {

            if (!/\.(jpeg|jpg|png)$/i.test(file?.name)) {
                toast.error("Please select an image in JPEG, JPG, or PNG format.");
            } else if (file?.size >= 50000) {
                toast.error("Please select a logo with a size below 50KB.");
            } else {
                const reader = new FileReader();

                reader.onload = () => {
                    // atob(item?.logo)
                    // console.log("base64======", reader.result)
                    const SplitBase64 = reader.result.split("base64,");
                    // console.log("SplitBase64======", SplitBase64[1])
                    const encodedString = btoa(reader.result);
                    setSelectedImageTwo(reader.result);
                    setSelectedImageTwoShow(reader.result);
                };
                reader.readAsDataURL(file);
            }

        }
    };
    // console.log(buildingName)
    

    const handleChangePincode = (e) => {
        const value = e.target.value;
        // Remove non-digit characters and limit to 6 digits
        const cleanedValue = value.replace(/\D/g, '').slice(0, 6);
        setPinCode(cleanedValue);
        
      };



    return (
        <>
            {Loading ?
                <div className="loaderDiv">
                    <div className="loader"></div>
                </div>
                : null}
            <ToastContainer />
            <div className="row mt-5 pt-5" style={{ alignItem: 'center' }}>
                <div className="col-lg-6 col-md-6">
                    <div className="HeadingTop">
                        <h3> Buildings </h3>
                        <span> Manage and create buildings with their complete infomation.</span>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 mb-3 mb-md-0  text-right" style={{ alignContent: 'center' }}>
                    <select size="md" className="sltareamodal col-4 ml-auto" onChange={(e) => {
                        setClientIdSelected(e?.target?.value);
                    }}>
                        <option value="">All Clients</option>
                        {ClientList ? ClientList?.map((item, index) =>
                            <option key={index} value={item?.clientId}>{item?.clientDisplayName}</option>
                        ) : null}
                    </select>
                    <Button variant="btn btn-info " onClick={openCreateModal}>+ Create New </Button>{' '}
                </div>
            </div>

            <Modal scrollable fullscreen={fullscreen} show={show} onHide={() => CloseModal()} dialogclassName="modal-100w clientmodal" class="modal-dialog modal-fullscreen">
                <Modal.Header className="headerMDL" closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg" onClick={openCreateModal}>
                        {/* Add New Building */}
                        {ShowTag ? <>Update Building</> : <>Add Building</>}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="row" id="validation">
                        <div className="col-12">
                            <form
                                action="#"
                                className="validation-wizard wizard-circle wizard clearfix"
                                role="application"
                                id="steps-uid-0"
                                novalidate="novalidate"
                            >
                                <div>
                                    <div className="row">
                                        <div className="col-lg-2 col-md-12 col-sm-12 col-12 border_area">
                                            <div className="form-group">
                                                <label for="webUrl3" className="mt-4">Logo <span className="danger">*</span></label>
                                                {/* <input type="file" onChange={(e)=>handleFileInputChangeTwo(e)} className="form-control required"  name="webUrl3" aria-required="true" />
                                        <div className='img_uploaded'>
                                            {selectedImageTwo && <img src={selectedImageTwo} alt="Selected Image" />}
                                        </div> */}
                                                <br />
                                                {!selectedImageTwo ? <div className='img_uploaded'><img src={clientDemoImg} alt="Selected Image" /></div>
                                                    : <div className='img_uploaded'>
                                                        {selectedImageTwo && <img src={selectedImageTwo} alt="Selected Image" />}
                                                    </div>

                                                }


                                                <label for="file-upload" className="custom-file-upload">
                                                    Browse Logo
                                                </label>
                                                <input id="file-upload" type="file" onChange={(e) => handleFileInputChangeTwo(e)} />
                                                <label className="text-danger mb-0"><span className="danger">*</span> Allowed File Types- JPEG/JPG/PNG.</label>
                                                <label className="text-danger mb-0"><span className="danger">*</span>Maximum image size - 50KB</label>
                                            </div>
                                        </div>
                                        <div className="col-lg-10 col-md-12 col-sm-12 col-12">
                                            <div className="row">
                                                <div className="col-md-4 mb-2">
                                                    <div className="form-group">
                                                        <label for="wfirstName2">
                                                            {" "}
                                                            Client Name  <span className="danger">*</span>{" "}
                                                        </label>
                                                        <select name="taskTypes" style={{height: 30}}  className="form-control" value={ClientId} onChange={(e) => {
                                                            setClientId(e?.target?.value[0]);
                                                        }
                                                        } disabled>
                                                            {/* {ClientName ? 
                                                <option value={ClientId}>{ClientName}</option>
                                                : */}
                                                            <option value="Select">Select</option>
                                                            {/* } */}
                                                            {ClientList ? ClientList.map((item, index) =>
                                                                <option key={index} value={item?.clientId}>{item?.clientDisplayName}</option>
                                                            ) : null}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 mb-2">
                                                    <label for="wfirstName2"> Building Name  <span className="danger">*</span> </label>
                                                    <input type='text' value={BuildingName} onChange={(e) => { setBuildingName(e.target.value) }} className="form-control required" />
                                                </div>
                                                <div className="col-md-4 mb-2">
                                                    <label for="wlastName2">Building Short Name  <span className="danger">*</span> </label>
                                                    <input value={BuildingShortName} onChange={(e) => { setBuildingShortName(e.target.value) }} type="text" className="form-control required" id="wlastName2" name="lastName" aria-required="true" />
                                                </div>
                                                <div className="col-md-4 mb-2">
                                                    <div className="form-group">
                                                        <label for="wemailAddress2"> Phone Number  <span className="danger">*</span> </label>
                                                        <input type="number" value={PhoneNumber} onChange={(e) => { setPhoneNumber(e.target.value) }} className="form-control required" id="wemailAddress2" name="emailAddress" aria-required="true" />
                                                    </div>
                                                </div>
                                                <div className="col-md-4 mb-2">
                                                    <div className="form-group">
                                                        <label for="wphoneNumber2">Alt Phone Number </label>
                                                        <input type="number" value={AltPhoneNumber} onChange={(e) => { setAltPhoneNumber(e.target.value) }} className="form-control" id="wphoneNumber2" />
                                                    </div>
                                                </div>
                                                <div className="col-md-4 mb-2">
                                                    <div className="form-group">
                                                        <label for="wlastName2"> Email  <span className="danger">*</span> </label>
                                                        <input type="email" value={Email} onChange={(e) => { setEmail(e.target.value) }} className="form-control required" id="wlastName2" name="lastName" aria-required="true" />
                                                    </div>
                                                </div>
                                                <div className="col-md-4 mb-2">
                                                    <div className="form-group">
                                                        <label for="jobTitle2">Alt Email </label>
                                                        <input type="email" value={AltEmail} onChange={(e) => { setAltEmail(e.target.value) }} className="form-control required" id="jobTitle2" aria-required="true" />
                                                    </div>
                                                </div>
                                                <div className="col-md-4 mb-2">
                                                    <div className="form-group">
                                                        <label for="webUrl3">SPOC Name </label>
                                                        <input type="url" value={SpocName} onChange={(e) => { setSpocName(e.target.value) }} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                                                    </div>
                                                </div>
                                                <div className="col-md-4 mb-2">
                                                    <div className="form-group">
                                                        <label for="webUrl3">SPOC Mobile Number </label>
                                                        <input type="number" value={SpocMobileNumber} onChange={(e) => { setSpocMobileNumber(e.target.value) }} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                                                    </div>
                                                </div>
                                                <div className="col-md-4 mb-2">
                                                    <div className="form-group">
                                                        <label for="jobTitle2">SPOC Email</label>
                                                        <input type="text" value={SpocEmail} onChange={(e) => { setSpocEmail(e.target.value) }} className="form-control required" id="jobTitle2" aria-required="true" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div class="col-lg-12 col-md-6 col-sm-12 col-12">
                                                    <div class="row">

                                                        <div className="col-md-2 mb-2">
                                                            <div className="form-group">
                                                                <label for="webUrl3">Alt SPOC Name </label>
                                                                <input type="url" value={AltSpocName} onChange={(e) => { setAltSpocName(e.target.value) }} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2 mb-2">
                                                            <div className="form-group">
                                                                <label for="webUrl3">Alt SPOC Mobile Number</label>
                                                                <input type="number" value={altSPOCMobileNumber} onChange={(e) => { setaltSPOCMobileNumber(e.target.value) }} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2 mb-2">
                                                            <div className="form-group">
                                                                <label for="jobTitle2">Alt SPOC Email</label>
                                                                <input type="text" value={AltaltSpocEmail} onChange={(e) => { setAltaltSpocEmail(e.target.value) }} className="form-control required" id="jobTitle2" aria-required="true" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2 mb-2">
                                                            <div className="form-group">
                                                                <label for="webUrl3">Address Line 1 <span className="danger">*</span></label>
                                                                <input type="text" value={AddressLineOne} onChange={(e) => { setAddressLineOne(e.target.value) }} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2 mb-2">
                                                            <div className="form-group">
                                                                <label for="webUrl3">Address Line 2</label>
                                                                <input type="text" value={AddressLineTwo} onChange={(e) => { setAddressLineTwo(e.target.value) }} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-2 mb-2">
                                                            <div className="form-group fixChevron">
                                                                <label >Country <span className="danger">*</span></label>
                                                                <select name="taskTypes" style={{height: 30}} className="form-control" value={SelectCountry} onChange={(e) =>
                                                                    setSelectCountry(e.target.value)} disabled>
                                                                    {Country ? Country?.map((item, index) => (
                                                                        <option key={index} value={item?.countryId}> {item?.countryName} </option>
                                                                    ))
                                                                        : null}
                                                                </select>
                                                                <FaChevronDown className="absChevron" size={"10px"}/>  
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12 col-md-6 col-sm-12 col-12">
                                                    <div class="row">

                                                        <div className="col-lg-2 col-md-6 col-sm-12 mb-2">
                                                            <div className="form-group fixChevron">
                                                                <label>State <span className="danger">*</span></label>
                                                                <select name="taskTypes" style={{height: 30}} className="form-control" value={SelectState} onChange={(e) => { setSelectState(e.target.value.split(",")) }} onClick={CityUpdate}>
                                                                    <option value="0">Select state</option>
                                                                    {State ? State?.map((item, index) => (
                                                                        <option key={index} value={[item?.stateId, item?.stateName]}> {item?.stateName} </option>
                                                                    ))
                                                                        : null}
                                                                </select>
                                                                <FaChevronDown className="absChevron" size={"10px"}/>   
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-2 col-md-6 col-sm-12 mb-2">
                                                            <div className="form-group fixChevron">
                                                                <label for="jobTitle2">City <span className="danger">*</span></label>
                                                                <select name="taskTypes" style={{height: 30}} className="form-control" value={SelectCity} onChange={(e) =>
                                                                    setSelectCity(e.target.value)} onClick={CheckCity}>
                                                                    <option value="0">Select city</option>
                                                                    {City ? City?.map((item, index) => (
                                                                        <option key={index} value={item?.cityName}> {item?.cityName} </option>
                                                                    ))
                                                                        : null}
                                                                </select>
                                                                <FaChevronDown className="absChevron" size={"10px"}/>   
                                
                                                                {/* <input type="text" value={City} onChange={(e) => setCity(e.target.value)} className="form-control required" id="jobTitle2" aria-required="true" /> */}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-2 col-md-6 col-sm-12 mb-2">
                                                            <div className="form-group">
                                                                <label for="jobTitle2">Pincode <span className="danger">*</span></label>
                                                                <input type="number" value={PinCode} maxlength="6" onChange={(e) => {setPinCode(e.target.value); handleChangePincode(e)}} className="form-control required" id="jobTitle2" aria-required="true" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-2 col-md-6 col-sm-12 mb-2">
                                                            <div className="form-group">
                                                                <label for="jobTitle2">Latitude</label>
                                                                <input type="text" value={Latitude} onChange={(e) => setLatitude(e.target.value)} className="form-control required" id="jobTitle2" aria-required="true" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-2 col-md-6 col-sm-12 mb-2">
                                                            <div className="form-group">
                                                                <label for="jobTitle2">Longitude</label>
                                                                <input type="text" value={Longitude} onChange={(e) => setLongitude(e.target.value)} className="form-control required" id="jobTitle2" aria-required="true" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-2 col-md-6 col-sm-12 mb-2">
                                                            <div className="form-group">
                                                                <label for="webUrl3">Edge DB Server IP/ Domain <span className="danger">*</span></label>
                                                                <input type="text" value={LocalDBServerName} onChange={(e) => { setLocalDBServerName(e.target.value) }} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-2 col-md-6 col-sm-12 mb-2 mt-2">
                                                            <div className="form-group">
                                                                <label for="webUrl3">Edge Server DB Name <span className="danger">*</span></label>
                                                                <input type="url" value={LocalDBName} onChange={(e) => { setLocalDBName(e.target.value) }} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-2 col-md-6 col-sm-12 mb-2 mt-2">
                                                            <div className="form-group">
                                                                <label for="webUrl3">Edge Server API End Point <span className="danger">*</span></label>
                                                                <input type="url" value={LocalEndPoint} onChange={(e) => { setLocalEndPoint(e.target.value) }} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                               
                                            </div>
                                        </div>
                                    </div>
                                    {/* {getStepContent(activeStep)} */}
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="row cutomStriper">
                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                                        {AddBuildingBtn ?
                                                            <div className="row">
                                                                <div className="  align-self-start d-flex flex-row-reverse">

                                                                    <button type="button" className="btn btn-info" onClick={() => addNewBuilding()}> Submit</button>
                                                                    <button type="button" className="btn border bg-white" onClick={() => CloseModal()}> Cancel</button>
                                                                </div>
                                                            </div>
                                                            : null}
                                                        {UpdateBuildingBtn ?
                                                            <div className="row">
                                                                <div className="  align-self-start d-flex flex-row-reverse">
                                                                <button type="button" className="btn btn-info" onClick={() => UpdateBuilding()}> Update</button>
                                                                    <button type="button" className="btn border bg-white" onClick={() => CloseModal()}> Cancel</button>
                                                                   
                                                                </div>
                                                            </div>
                                                            : null}
                                                        {MasterBtn ?
                                                            <div className="row">
                                                                <div className="   align-self-start d-flex flex-row-reverse">
                                                                    <button type="button" className="btn btn-info" onClick={() => addNewMasterBuilding()}> Try Again</button>
                                                                    <button type="button" className="btn border bg-white" onClick={() => CloseModal()}> Cancel</button>
                                                                </div>
                                                            </div>
                                                            : null}
                                                        {MasterBtnUpdate ?
                                                            <div className="row">
                                                                <div className="   align-self-start d-flex flex-row-reverse">
                                                                    <button type="button" className="btn btn-info" onClick={() => UpdateMasterBuilding()}> Try Again</button>
                                                                    <button type="button" className="btn border bg-white" onClick={() => CloseModal()}> Cancel</button>
                                                                </div>
                                                            </div>
                                                            : null}
                                                    </div>
                                                </div>

                </Modal.Body>
            </Modal>
            {/* {ClientList?.length && */}
            <div className='row'>
                {BuildingList ? BuildingList.map((item, index) =>
                    <div className="col-lg-3 col-md-6 col-sm-12 col-12" key={index}>
                        <div className='clientTiles' style={{ height: 240 }}>
                            <div className="ClientImg">
                                <div className="tabs_img">
                                    <img src={item?.logo} class="img img-responsive" alt="building-img" />
                                </div>
                                <div class="bars_font">
                                    <h3 className="font_trigger" onClick={() => { setInputValue(item); }} >
                                        <FontAwesomeIcon icon={faPenToSquare} />
                                    </h3>
                                    <h3 className="font_trigger" onClick={() => { ShowDeleteModal(item); }}>
                                        <FontAwesomeIcon icon={faTrashCan} />
                                    </h3>
                                </div>
                            </div>
                            <div className='ClientText' >
                                <div className="l-two">
                                    <h1> {item?.buildingName} </h1>
                                    <h4> {item?.clientDisplayName} </h4>
                                    <h4> {item?.email} </h4>
                                    <h4> {item?.phoneNumber}</h4>
                                    <h4> {item?.addressLine1} {item?.addressLine2}</h4>
                                    <h4> {item?.city}, {item?.state}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
            {/* } */}
            {!BuildingList?.length && BuildingList?.length != null &&
                <div className='bg-white' style={{ paddingBottom:"50px",  borderRadius: "10px" }}>
                    <div className='col-12 text-center'>
                        <img src={NoBuilding} alt="user" class="mx-auto mt-5" style={{ height: "100px" }} />
                    </div>
                    <br />
                    <h3 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "0px" }}> No building found</h3>
                    <h5 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "10px" }}> Click on Create New button to add a building</h5>
                </div>}
            <Modal centered show={DeleteShow} onHide={() =>
                setDeleteShow(false)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
                {/* <Modal.Header className="headerMDL" closeButton>
                    <Modal.Title id="contained-modal-title-vcenter" centered onClick={openCreateModal}>
                        <h4 className="mb-0"> Delete Vehicle </h4>
                    </Modal.Title>
                </Modal.Header> */}
                <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
                    <div className="row px-3" id="validation">
                        <div className="col-12 bg-white pt-3 pb-2">
                            <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
                                {/* <div className="FnFimg">
                                <img src={stopMark} className='img img-fluid img-responsive'  alt="placeholder" />
                            </div> */}
                                <div className="FnFtxt">
                                    <h2> Delete Building </h2>
                                    <h3> Are you sure you want to delete? </h3>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div className='confirmation_btn pb-4 pt-3 px-3' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
                        <div className='both_ConfrmBTN col-6' onClick={DeleteBuilding}>
                            <Button variant="danger">Delete</Button>{' '}
                        </div>
                        <div className='both_ConfrmBTN col-6' onClick={() => setDeleteShow(false)} >
                            <Button variant="light"> Cancel</Button>{' '}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal centered show={WarningShow} onHide={() =>
                setWarningShow(false)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
                <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
                    <div className="row px-3" id="validation">
                        <div className="col-12 bg-white pt-3 pb-2">
                            <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
                                <div className="FnFtxt">
                                    <h2> Warning</h2>
                                    <h3>Local building could not be updated. Please verify below points-</h3>
                                    <h3 className='mb-0'>1. Local server must be up and running. </h3>
                                    <h3 className='mb-0'>2. Verify values for Local API Endpoints, Local DB Server Name and Local DB Name.</h3>
                                    <h3 className='mb-0'>3. Click on Try Again button to add local building </h3>
                                    <h3 className='mb-0'>4. In case if local building could not be added, inform CuroNext technical support team. </h3>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div className='confirmation_btn pb-3 pt-0 px-2' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
                        <div className='both_ConfrmBTN col-6' onClick={() => setWarningShow(false)}>
                            <Button variant="light ok_btn">OK</Button>{' '}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal centered show={WarningUpdateShow} onHide={() =>
                setWarningUpdateShow(false)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
                <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
                    <div className="row px-3" id="validation">
                        <div className="col-12 bg-white pt-3 pb-2">
                            <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
                                <div className="FnFtxt">
                                    <h2> Warning</h2>
                                    <h3>Local building could not be updated. Please verify below points-</h3>
                                    <h3 className='mb-0'>1. Local server must be up and running. </h3>
                                    <h3 className='mb-0'>2. Verify values for Local API Endpoints, Local DB Server Name and Local DB Name.</h3>
                                    <h3 className='mb-0'>3. Click on Try Again button to update local building. </h3>
                                    <h3 className='mb-0'>4. In case if local building could not be updated, inform CuroNext technical support team.</h3>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div className='confirmation_btn pb-3 pt-0 px-2' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
                        <div className='both_ConfrmBTN col-6' onClick={() => setWarningUpdateShow(false)}>
                            <Button variant="light ok_btn" >OK</Button>{' '}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )

}
export default Building